// https://vuex.vuejs.org/en/mutations.html

export default {
    login(state) {
        state.isLoggedIn = true
    },
    logout(state) {
        state.isLoggedIn = false
    }
}
